<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <div slot="modal-header" class="w-100">
        <h5>Send to Patient<button type="button" class="close" @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
        </h5>
      </div>
    </div>
    <b-form>
      <div class="row">
        <div class="col-2">
        </div>
        <div class="col-8">
          <b-form-checkbox v-model="sendEmail" :disabled="!email" switch>
            <span style="vertical-align:middle">Email<span v-show="email.length > 0"> to {{ email }}</span></span>
          </b-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
        </div>
        <div class="col-8" style="vertical-align: top">
          <b-form-checkbox v-model="sendText" :disabled="!phoneNumber" switch>
            <span style="vertical-align:middle">SMS/Text<span v-show="phoneNumber.length > 0"> to {{ phoneNumber }}</span></span>
          </b-form-checkbox>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" :disabled="sendEmail == false && sendText == false" @click.prevent="sendEstimate()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>Send
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'EstimateSendModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      estimate: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        hasCellPhone: true,
        hasEmail: true,
        isSaving: false,
        notifications: [],
        notificationId: 0,
        sendEmail: true,
        sendText: true
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue && this) {
          const phone = this.phoneNumber
          this.hasCellPhone = (phone.length > 0)
        }
      },

      estimate (newValue, oldValue) {
        if (newValue && this) {
          const email = this.email
          this.sendEmail = (email.length > 0)

          const phone = this.phoneNumber
          this.sendText = (phone.length > 0)
        }
      }
    },

    computed: {
      email () {
        let em = ''

        if (this.estimate.patient) {
          if (this.estimate.patient.email) {
            em = (this.estimate.patient.email === '() -') ? '' : this.estimate.patient.email
          }
        }

        return em
      },

      phoneNumber () {
        let phone = ''

        if (this.estimate.patient) {
          if (this.estimate.patient.phoneNumber) {
            phone = (this.estimate.patient.phoneNumber === '() -') ? '' : this.estimate.patient.phoneNumber
          }
        }

        return phone
      }
    },

    methods: {
      sendEstimate () {
        if (this.isSaving) { return }

        const parameters = {
          sendEmail: this.sendEmail,
          sendText: this.sendText
        }

        this.isSaving = true
        const sendPostRequest = async () => {
          try {
            setTimeout(() => { this.closeModal() }, 2000)
            await api.post('/Dashboard/Estimate/' + this.estimate.organizationPatientEstimateId + '/SendToPatient', parameters)
          } catch (err) {
            // Handle Error Here
            console.error(err)
          }
        }

        sendPostRequest()
      },

      closeModal () {
        this.isSaving = false
        this.$emit('update:visible', false)
      }
    }
  }
</script>
